import React from 'react';
import FormGroupWrapper from '../blocks/FormGroupWrapper';

type SelectItem = { id: string | number; title: string };

type Props = {
  id: string;
  name?: string;
  items: Array<SelectItem>;
  labelClass?: string;
  groupClass?: string;
  selectClass: string;
  onSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value: number | string | '';
  label: string;
  isDisabled?: boolean;
  includeChooseOption?: boolean;
};

const Select = (props: Props): React.ReactElement => {
  const {
    id, items, selectClass, labelClass, onSelectChange,
    value, label, name, groupClass, isDisabled, includeChooseOption,
  } = props;
  let classes = 'form-group';
  if (groupClass) {
    classes += ` ${groupClass}`;
  }

  return (
    <FormGroupWrapper groupClasses={classes}>
      <label htmlFor={id} className={labelClass}>{label}</label>
      <select
        className={selectClass}
        id={id}
        name={name}
        value={value}
        onChange={onSelectChange}
        disabled={isDisabled}
      >
        {includeChooseOption && <option value="">{'Please choose a ' + id}</option>}
        {items.map(item => <option value={item.id} key={item.id}>{item.title}</option>)}
      </select>
    </FormGroupWrapper>
  );
};

export default Select;
